import { T } from "@/i18n";
import { ReactNode, useRef, useState } from "react";
import { LoadingSpinner } from "./loading-spinner";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./ui/alert-dialog";

export function DeletePrompt({
  children,
  translations,
  onProceed,
}: {
  children?: ReactNode;
  translations: {
    title: string;
    description: string;
    cancel: string;
    continue: string;
  };
  onProceed: () => void | Promise<void>;
}) {
  const [loading, setLoading] = useState(false);
  const cancelRef = useRef<HTMLButtonElement>(null);
  const onDelete = async () => {
    try {
      setLoading(true);
      const res = onProceed();
      if (res instanceof Promise) {
        await res;
      }
      cancelRef.current?.click();
    } finally {
      setLoading(false);
    }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <T tKey={translations.title} />
          </AlertDialogTitle>
          <AlertDialogDescription>
            <T tKey={translations.description} />
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel ref={cancelRef} disabled={loading}>
            <T tKey={translations.cancel} />
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(ev) => {
              ev.preventDefault();
              onDelete();
            }}
          >
            {loading ? <LoadingSpinner /> : <T tKey={translations.continue} />}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
